// Novo arquivo para funções de autenticação
import store from '@/store';

export function clearAllAuthData() {
  // Limpar localStorage e sessionStorage
  localStorage.clear();
  sessionStorage.clear();

  // Limpar todos os cookies
  document.cookie.split(';').forEach((c) => {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=Thu, 01 Jan 1970 00:00:00 GMT ;path=/');
  });

  // Limpar store do Vuex
  store.commit('setCompanyData', {});
  store.commit('setCompanyName', '');
  store.commit('setUserId', '');

  // Limpar cache MSAL
  if (window.$msal) {
    try {
      window.$msal.clearCache();
    } catch (error) {
      window.$swal.fire({
        title: 'Erro no Logout',
        html: 'Ocorreu um erro ao fazer logout do Microsoft Entra ID. <br/> Você será redirecionado para o login mesmo assim.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
    }
  }
}
